import * as Actions from './constants'

const initState = {
  loading: true,
}

export default function loadingReducer(state = initState, action = {}) {
  switch (action.type) {
    case Actions.LOADING_DATA:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

const initStates = {
  online: true,
}
export function onlineReducer(state = initStates, action = {}) {
  switch (action.type) {
    case Actions.LOADING_ONLINE:
      return {
        ...state,
        online: action.payload,
      }
    default:
      return state
  }
}
